import "antd/lib/card/style";
import _Card from "antd/lib/card";
import "antd/lib/divider/style";
import _Divider from "antd/lib/divider";
import "antd/lib/space/style";
import _Space from "antd/lib/space";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "antd/lib/typography/style";
import _Typography from "antd/lib/typography";
var __jsx = React.createElement;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { modules } from 'utils/constants';
import { useAppRouter } from 'utils/AppRouteProvider';
var Title = _Typography.Title;
var LandingPage = function LandingPage() {
  var _useAppRouter = useAppRouter(),
    navigateTo = _useAppRouter.navigateTo;
  var _useState = useState(false),
    shouldRenderLandingPage = _useState[0],
    setShouldRenderLandingPage = _useState[1];
  useEffect(function () {
    var fetchLastVisitedPage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var lastVisitedPage;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return localStorage.getItem('lastVisitedPage');
              case 2:
                lastVisitedPage = _context.sent;
                if (lastVisitedPage) {
                  navigateTo(lastVisitedPage);
                } else {
                  setShouldRenderLandingPage(true);
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function fetchLastVisitedPage() {
        return _ref.apply(this, arguments);
      };
    }();
    fetchLastVisitedPage();
  }, []);
  if (shouldRenderLandingPage) {
    return __jsx("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
      }
    }, __jsx(_Space, {
      direction: "vertical"
    }, __jsx("div", {
      style: {
        textAlign: 'center',
        width: '100%'
      }
    }, __jsx(Title, {
      level: 2
    }, "Welcome to the Parse Biosciences cloud analysis platform!")), __jsx("br", null), __jsx(_Card, {
      style: {
        width: '100%',
        maxWidth: '900px'
      },
      bordered: true
    }, __jsx(_Space, {
      direction: "vertical",
      size: "large"
    }, __jsx(Title, {
      level: 3
    }, "I am a Parse Biosciences customer and I have Fastq files from a Parse Biosciences kit."), __jsx(_Space, {
      direction: "horizontal"
    }, __jsx("p", null, "The Pipeline module is where you can upload your Parse Biosciences Fastq files for alignment to your selected genome. The Pipeline module outputs include a Quality Control report, downloadable count matrices and automated integration with downstream Insights module."), __jsx(_Button, {
      size: "large",
      type: "primary",
      onClick: function onClick() {
        return navigateTo(modules.SECONDARY_ANALYSIS);
      }
    }, "Take me to Pipeline")), __jsx(_Divider, {
      orientation: "center"
    }, "OR"), __jsx(Title, {
      level: 3
    }, "I have processed data files, such as Pipeline output files, count matrices or a Seurat object."), __jsx(_Space, {
      direction: "horizontal"
    }, __jsx("p", null, "The Insights module is where you can upload files that have already been pre-processed. Supported file types include: output files from the Pipeline module, count matrices of multiple technology types, H5 files, and Seurat objects. Explore your data and generate publication-ready figures with Insights!"), __jsx(_Button, {
      size: "large",
      type: "primary",
      onClick: function onClick() {
        return navigateTo(modules.DATA_MANAGEMENT);
      }
    }, "Take me to Insights"))))));
  }
};
export default LandingPage;